import * as React             from 'react';
import { bindActionCreators } from 'redux';
import { connect }            from 'react-redux';
import * as actions           from '../../../actions';
import InvestComponent        from './invest-component';
import LocalAuthority         from '../../../model/local-authority';
import ResultsService         from '../../../service/sfp/results-service';
import RestsService           from '../../../service/sfp/rests-service';
import Result                 from '../../../model/result';
import Rest                   from '../../../model/rest';


// FIXME:
// Fixer le problème de la response Json sur les services results et rests

const ROW_ID_INVESTMENT_EXPENSE  = "INVESTMENT_EXPENSE"
const ROW_ID_INVESTMENT_RECEIPT  = "INVESTMENT_RECEIPT"
const ROW_ID_INVESTMENT_RESULT   = "INVESTMENT_RESULT"
const ROW_ID_PREVIOUS_RESULT     = "PREVIOUS_RESULT"
const ROW_ID_REST_INVEST_EXPENSE = "REST_INVESTMENT_EXPENSE"
const ROW_ID_REST_INVEST_RECEIPT = "REST_INVESTMENT_RECEIPT"
const ROW_ID_RESULT_TOTAL        = "RESULT_TOTAL"
const RESULT_TOTAL               = "Résultat cumulé section investissement"

class InvestContainer extends React.Component {
	constructor(props) {
		super(props);
		this.state = { data: [] }
    }

	render() {
		return (
			<InvestComponent
            data                = {this.state.data}
            localAuthority      = {this.props.localAuthority}
			onAfterChange       = {this._onAfterChange}
			years               = {this.props.years}
            />
		)
	}

	componentDidMount() {
		if (!this.props.localAuthority) return
        this._setData(this.props);
    }

    componentWillReceiveProps(nextProps) {
		if (!nextProps.localAuthority) return
        this._setData(nextProps);
    }

	_setData = (props, replaceRow) => {
		let data = [...props.data, ...this._getDataRecap(props.localAuthority, props.dataInvestReceipts, props.dataInvestExpense, props.years)]
		let newData = _.cloneDeep(data)
		newData = this._updateData(newData, replaceRow, props.years);
		this.setState({ data: newData })
    }

	_createRest = (
        /** @type {Rest} */        rest,
        /** @type {Number} */      index,
        /** @type {String} */      column,
        /** @type {Number} */      oldAmount) => {
    RestsService.createRest(this.props.currentLocalAuthority, rest)
        .then(
            this._updateCellRest.bind(this, index, column, rest),
            this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
        );
	}

	_createResult = (
        /** @type {Result} */      result,
        /** @type {Number} */      index,
        /** @type {String} */      column,
        /** @type {Number} */      oldAmount) => {
    ResultsService.createResult(this.props.localAuthority, result)
        .then(
            this._updateCellResult.bind(this, index, column, result),
            this._rejectSaveResult.bind(this, result, index, column, oldAmount)
        );
    }

	_deleteRest = (
        /** @type {Rest} */        rest,
        /** @type {Number} */      index,
        /** @type {String} */      column,
        /** @type {Number} */      oldAmount) => {
    RestsService.deleteRest(this.props.currentLocalAuthority, rest)
        .then(
            this._removeCellContent.bind(this, index, column),
            this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
        );
	}

    _deleteResult = (
        /** @type {Result} */      result,
        /** @type {Number} */      index,
        /** @type {String} */      column,
        /** @type {Number} */      oldAmount) => {
    ResultsService.deleteResult(this.props.localAuthority, result)
        .then(
            this._removeCellContent.bind(this, index, column),
            this._rejectSaveResult.bind(this, result, index, column, oldAmount)
        );
	}

	_getDataRecap = (
		/** @type {LocalAuthority} */   localAuthority,
        /** @type {Object[]} */         dataInvestReceipts,
		/** @type {Object[]} */         dataInvestExpense,
        /** @type {Number[]} */         years ) => {

		let listOperationOrderReceipt = this._getOrderOperation(localAuthority.accounts, localAuthority.observations, false, true, years)
		let listOperationOrderExpense = this._getOrderOperation(localAuthority.accounts, localAuthority.observations, false, false, years)
        let obj                       = {label: null};
        let tab                       = [];
		const loading                 = {}
		const title                   = {label: RESULT_TOTAL, isTitle: true}
		tab.push(title)

        years.forEach(y => {
            const year = y.toString()
            obj[year] = _.sumBy(dataInvestReceipts, row => {
                if (row.id && (row.id === "receipts" || row.id === "orderoperation" || row.id === "receiptsFinancial"|| row.id === "receiptsEquipment"))
                    return row[year]
            })
        })
        obj.id = ROW_ID_INVESTMENT_RECEIPT
        obj.isCurrency = true
        obj.label = "Total recette investissement";
        tab.push(obj)
        obj = {};

        this._initializeValues(obj, years)

        years.forEach(y => {
            const year = y.toString()
            obj[year] = _.sumBy(dataInvestExpense, row => {
                if (row.id && (row.id === "expense" || row.id === "orderoperation" || row.id === "expenseEquipment" || row.id === "expenseFinancial"))
                    return row[y.toString()]
            })
        })
		obj.id         = ROW_ID_INVESTMENT_EXPENSE
		obj.isCurrency = true
		obj.label      = "Total dépense investissement"
        tab.push(obj)
        obj = {};

		this._initializeValues(obj, years)

		years.forEach(y => {
			const resYearMinus1 = _.find(localAuthority.results, r =>r.year === y-1 && r.operation === false)
			if(undefined === resYearMinus1) { obj[y.toString()] = 0; }
			else {
                resYearMinus1.loading = false;
				obj[y.toString()]     = resYearMinus1.amount;
				loading[y.toString()] = false
            }
		})
		obj.editable   = !this.props.consulted
		obj.id         = ROW_ID_PREVIOUS_RESULT
		obj.isCurrency = true
		obj.label      = "Résultat N-1";
		obj.loading    = loading
		obj.rowId      = ROW_ID_PREVIOUS_RESULT;
        tab.push(obj)
        obj = {};

		this._initializeValues(obj, years)

		years.forEach(y => {
            const restToDoReceipt = _.find(localAuthority.rests, r => r.year === y-1 && r.receipt === true)
			if(undefined === restToDoReceipt) { obj[y.toString()] = 0; }
			else {
                restToDoReceipt.loading = false;
                obj[y.toString()] = restToDoReceipt.amount;
            }
		})
		obj.editable   = !this.props.consulted
		obj.id         = ROW_ID_REST_INVEST_RECEIPT
		obj.isCurrency = true
		obj.label      = "Reste à réaliser recettes d'investissement";
		obj.loading    = loading
        tab.push(obj);
		obj = {};

		this._initializeValues(obj, years)

		years.forEach(y => {
            const restToDoExpense = _.find(localAuthority.rests, r => r.year === y-1 && r.receipt === false)
			if(undefined === restToDoExpense) { obj[y.toString()] = 0; }
			else {
                restToDoExpense.loading = false;
                obj[y.toString()] = restToDoExpense.amount;
            }
		})
		obj.editable   = !this.props.consulted
		obj.id         = ROW_ID_REST_INVEST_EXPENSE
		obj.isCurrency = true
		obj.label      = "Reste à réaliser depenses d'investissement";
		obj.loading    = loading
        tab.push(obj);
        obj = {}

        return tab;
	}

	_getOrderOperation = (
        /** @type {Account[]} */     accounts,
        /** @type {Observation[]} */ observations,
        /** @type {Boolean} */       operation,
        /** @type {Boolean} */       receipts,
        /** @type {Number[]} */      years
    ) => {
        let listChapter = [];
        let orderOperationTotal = {id: 'orderoperation', label: 'Opération d\'ordre'};

        // On filtre les accounts afin d'avoir uniquement les comptes d'opération d'ordre
        let filteredArranged = accounts
            .filter(laca => (
                laca.account
                && laca.account.operation === operation
                && laca.account.receipts === receipts
                && laca.chapter
                && _.some(laca.chapter.types, type => type && type.operationType.id === "ORDER")
                && laca.chapter.number.startsWith("0")
            ));

        // Initialisation de l'objet orderOperationTotal afin de +=
        this._initializeValues(orderOperationTotal, years)

        // On ajoute chaque chapitre qu'une seule fois à une liste -> listChapter
        filteredArranged.forEach(fa => {
            if(!_.some(listChapter, ch => ch.chapter.number === fa.chapter.number)) {
                listChapter.push({chapter: fa.chapter, account: fa.account, label: fa.chapter.label});
            }
        })

        // On map les lignes de data avec les infos des lignes de listChapter
        const data = listChapter.map(info => {
            const row = { info };
            // Pour chaque année on filtre les nouvelles observations par rapport à y, receipts, operation
            years.forEach(y => {
                const obs = _.filter(observations, (/** @type {Observation}*/ o) => {
                    const obsIndexedAccount = _.find(filteredArranged, c => o.account.id === c.account.id);
                    const isSameYear      = o.year === y;
                    const isSameReceipts  = o.account.receipts === receipts;
                    const isSameOperation = o.account.operation === operation;
                    return obsIndexedAccount && obsIndexedAccount.chapter && obsIndexedAccount.chapter.id === info.chapter.id  && isSameYear && isSameReceipts && isSameOperation;
                })
                row[y] = _.round(_.sumBy(obs, o => o.amount), 2);
                orderOperationTotal[y.toString()] += row[y.toString()]
            })
            row.isCurrency = true
            row.label      = info.chapter.label
            return row
        });
        orderOperationTotal.isCurrency = true
        orderOperationTotal.isTitle    = true
        data.push(orderOperationTotal)
        return data;
	}

	_getResultatSection = (
		/** @type {Object[]} */ tab,
		/** @type {Number[]} */ years) => {
		const index_investment_expense = tab.findIndex(row => row && ROW_ID_INVESTMENT_EXPENSE === row.id)
		const index_investment_receipt = tab.findIndex(row => row && ROW_ID_INVESTMENT_RECEIPT === row.id)
		const index_previous_result    = tab.findIndex(row => row && ROW_ID_PREVIOUS_RESULT    === row.id)
		const loading                  = {}
		let obj                        = {}

		this._initializeValues(obj, years)

		years.forEach(y => {
            obj[y.toString()]     = _.round((tab[index_investment_receipt][y.toString()] - tab[index_investment_expense][y.toString()]) + tab[index_previous_result][y.toString()], 2)
			loading[y.toString()] = false
        })
		obj.isCurrency = true
		obj.label      = "Résultat section investissement"
		obj.loading    = loading
		obj.rowId      = ROW_ID_INVESTMENT_RESULT
		return obj
	}

	_getResultatTotal = (
		/** @type {Object[]} */ tab,
		/** @type {Number[]} */ years) => {
		const index_investment_rest_expense  = tab.findIndex(row => row && ROW_ID_REST_INVEST_EXPENSE === row.id)
		const index_investment_rest_receipt  = tab.findIndex(row => row && ROW_ID_REST_INVEST_RECEIPT === row.id)
		const investment_result              = this._getResultatSection(tab, years)
		const loading = {}
		let obj = {}

		years.forEach(y => {
			obj[y.toString()]     = _.round((investment_result[y.toString()] - tab[index_investment_rest_expense][y.toString()]) + tab[index_investment_rest_receipt][y.toString()], 2)
			loading[y.toString()] = false
		})
		obj.id         = ROW_ID_RESULT_TOTAL
		obj.isTitle    = true
		obj.isCurrency = true
		obj.label      = RESULT_TOTAL
		obj.loading    = loading
		return obj
	}

	_initializeValues = (data, years) => {
		years.forEach(y => {
			data[y.toString()] = 0
		})
	}

	_onAfterChange = (
		/** @type {Object[]} */        changes,
        /** @type {LocalAuthority} */  localAuthority ) => {

		const amount           = changes[0][3]
		const oldValue         = changes[0][2]
		if (amount === oldValue) return

		const column           = changes[0][1]
		const data             = this.state.data
		const indexResult      = data.findIndex(row => row && ROW_ID_PREVIOUS_RESULT     === row.id)
		const indexRestReceipt = data.findIndex(row => row && ROW_ID_REST_INVEST_RECEIPT === row.id)
		const indexRestExpense = data.findIndex(row => row && ROW_ID_REST_INVEST_EXPENSE === row.id)
		const row              = changes[0][0]
		const year             = parseInt(column) - 1
		let receiptValue

		if(indexRestReceipt === row) receiptValue = true
		if(indexRestExpense === row) receiptValue = false

		const result   = new Result(localAuthority, false, oldValue, year)
		const rest     = new Rest(localAuthority, receiptValue, oldValue, year)

		data[row]["loading"][column] = true

		switch(row)
		{
			case indexResult:
				this._saveResult(row, column, result, amount, oldValue);
				break;
			case indexRestReceipt:
			case indexRestExpense:
				this._saveRest(row, column, rest, amount, oldValue, receiptValue);
		}

	}

	_rejectSaveRest = (
		/** @type {Rest} */        rest,
		/** @type {Number} */      index,
		/** @type {Number} */      column,
		/** @type {Number} */      oldAmount,
		/** @type {Error} */       error) => {
		rest.amount = oldAmount;
		this._updateCellRest(index, column, rest);
		this.props.actions.throwError(error);
	}

    _rejectSaveResult = (
            /** @type {Result} */      result,
            /** @type {Number} */      index,
            /** @type {Number} */      column,
            /** @type {Number} */      oldAmount,
            /** @type {Error} */       error) => {
        result.amount = oldAmount;
        this._updateCellResult(index, column, result);
        this.props.actions.throwError(error);
    }

    _removeCellContent = (
            /** @type {Number} */ row,
            /** @type {String} */ column) => {
        const data = this.state.data;
        data[row][column]            = 0
		data[row]["loading"][column] = false
		this._updateData(data, true, this.props.years);
		this.setState({ data })
	}

	_saveRest = (
		/** @type {Number} */  index,
		/** @type {String} */  column,
		/** @type {Rest} */    rest,
		/** @type {Number} */  amount,
		/** @type {Number} */  oldAmount) => {

		if ((rest && rest.amount == amount)
		|| (!rest && 0 == amount)) return;

		let rests               = this.props.localAuthority.rests ? this.props.localAuthority.rests : undefined
		const data              = this.state.data;
		data[index][column]     = data[index][column] || 0;
		this.setState({ data });

		if (0 === amount || undefined === amount) {
            rest.amount       = amount;
            this._deleteRest(rest, index, column, oldAmount);
        } else {
            let findRest        = rests ? rests.find(r => r.year === parseInt(column)-1 && r.amount === oldAmount && r.receipt === rest.receipt) : undefined
            if (findRest) {
                findRest.amount = amount
                this._updateRest(findRest, index, column, oldAmount)
            } else {
                this._createRest(new Rest(this.props.localAuthority, rest.receipt, amount, parseInt(column)-1), index, column, oldAmount);
            }
        }
	}

    _saveResult = (
            /** @type {Number} */            index,
            /** @type {String} */            column,
            /** @type {Result} */            result,
            /** @type {Number} */            amount,
            /** @type {Number} */            oldAmount) => {
        if ((result && result.amount == amount)
        || (!result && 0 == amount)) return;

        let results         = this.props.localAuthority.results ? this.props.localAuthority.results : undefined
        amount              = parseFloat(amount)
        const data          = this.state.data;
        data[index][column] = data[index][column] || 0;

        this.setState({ data });

        if (0 === amount || undefined === amount) {
            result.amount = amount;
            this._deleteResult(result, index, column, oldAmount);
        } else {
            let findResult        = results ? results.find(r => r.year === parseInt(column)-1 && r.amount === oldAmount && r.operation === false) : undefined
            if(findResult) {
                findResult.amount = amount
                this._updateResult(findResult, index, column, oldAmount)
            } else {
                this._createResult(new Result(this.props.localAuthority, false, amount, parseInt(column)-1), index, column, oldAmount);
            }
        }
    }

	_updateData = (
		/** @type {Object[]} */   data,
		/** @type {Boolean} */    replaceRow,
		/** @type {Number[]} */   years
	) => {
		const replace = replaceRow ? 1 : 0
		data.splice(data.findIndex(row => row && ROW_ID_PREVIOUS_RESULT === row.id) + 1, replace, this._getResultatSection(data, years))
		if (replace) {
			data.splice(data.findIndex(row => row && ROW_ID_RESULT_TOTAL === row.id), replace, this._getResultatTotal(data, years))
		} else {
			data.push(this._getResultatTotal(data, years))
		}
		return data
	}

    _updateResult = (
        /** @type {Result} */      result,
        /** @type {Number} */      index,
        /** @type {Number} */      column,
        /** @type {Number} */      oldAmount) => {
    ResultsService.updateResult(this.props.localAuthority, result)
        .then(
            this._updateCellResult.bind(this, index, column, result),
            this._rejectSaveResult.bind(this, result, index, column, oldAmount)
        );
	}

	_updateRest = (
        /** @type {Rest} */     rest,
        /** @type {Number} */   index,
        /** @type {Number} */   column,
        /** @type {Number} */   oldAmount) => {
    RestsService.updateRest(this.props.localAuthority, rest)
        .then(
            this._updateCellRest.bind(this, index, column, rest),
            this._rejectSaveRest.bind(this, rest, index, column, oldAmount)
        );
    }

	_updateCellRest = (
		/** @type {Number} */      index,
		/** @type {Number} */      column,
		/** @type {Rest} */        rest) => {
	const data   = this.state.data;
	let   rests  = this.props.localAuthority.rests

	data[index][column]            = rest.amount;
	data[index]['loading'][column] = false;

	if (rest) rests.push(rest)
	this._updateData(data, true, this.props.years);
	this.setState({ data });
	}

    _updateCellResult = (
		/** @type {Number} */      row,
		/** @type {Number} */      column,
		/** @type {Result} */      result) => {
        let   results = this.props.localAuthority.results
        const data    = this.state.data

        data[row][column]            = result.amount
        data[row]["loading"][column] = false

		if (result) results.push(result)
		this._updateData(data, true, this.props.years);
        this.setState({ data });
	}
}

const mapStateToProps = state => state;
const mapDispatchToProps = (dispatch) => (
	{actions: bindActionCreators(actions, dispatch)}
);

export default connect(mapStateToProps, mapDispatchToProps)(InvestContainer);


// WEBPACK FOOTER //
// ./src/component/summary/investment/invest-container.js